import { type ErrorCodeMap } from './types';

export const sessionErrorCodes: ErrorCodeMap = {
  SESSION_ENGINE_NOT_RUNNING: 'desktop.errors.session.engineNotRunning',
  SESSION_ALREADY_RUNNING: 'desktop.errors.session.alreadyRunning',
  SESSION_AUTH_MISSING: 'desktop.errors.session.authMissing',
  SESSION_CREATION_FAILED: 'desktop.errors.session.creationFailed',
  SESSION_UPLOAD_FAILED: 'desktop.errors.session.uploadFailed',
  SESSION_NOTE_GENERATION_FAILED: 'desktop.errors.session.noteGenerationFailed',
  SESSION_IO_ERROR: 'desktop.errors.session.ioError',
};
